import React, { useEffect, useState } from "react";

// Track active requests
let activeRequests = 0;
let timeoutId: any = null;

const originalFetch = window.fetch;

window.fetch = async (...args) => {
  activeRequests++;
  window.dispatchEvent(new CustomEvent("globalLoadingChange", { detail: activeRequests > 0 }));

  try {
    const response = await originalFetch(...args);
    return response;
  } finally {
    activeRequests = Math.max(0, activeRequests - 1);
    window.dispatchEvent(new CustomEvent("globalLoadingChange", { detail: activeRequests > 0 }));
  }
};

export const GlobalLoader: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    const handleLoadingChange = (e: any) => {
      setIsLoading(e.detail);
    };

    window.addEventListener("globalLoadingChange", handleLoadingChange);
    return () => {
      window.removeEventListener("globalLoadingChange", handleLoadingChange);
    };
  }, []);

  useEffect(() => {
    if (isLoading) {
      // Show overlay only if loading takes more than 300ms to avoid flashing
      timeoutId = setTimeout(() => {
        setShowOverlay(true);
      }, 300);
    } else {
      if (timeoutId) clearTimeout(timeoutId);
      setShowOverlay(false);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isLoading]);

  if (!showOverlay) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(2px)",
      }}
    >
      <div className="spinner" style={{ width: "3rem", height: "3rem", borderWidth: "4px", borderColor: "rgba(0,0,0,0.1)", borderTopColor: "var(--tg-primary, #0056b3)" }}></div>
      <h3 style={{ marginTop: "1rem", color: "var(--tg-primary, #0056b3)", fontWeight: 600 }}>Loading, please wait...</h3>
    </div>
  );
};
